import { render, staticRenderFns } from "./ExpensesAccount.vue?vue&type=template&id=ccfdd7b0"
import script from "./ExpensesAccount.vue?vue&type=script&lang=js"
export * from "./ExpensesAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports